module.exports = __webpack_public_path__ + "assets/70b7641a4ab761ccefe71180c5aff497.woff";